module.exports = __webpack_public_path__ + "media/2_santanto_eguru_kokuhatusyaha_reikokuna_akashibitoto.dfc5b789.mp3";